import { ChildComponentGeneratorClient } from 'components/ContentHandlersAppRouter/ChildComponentGeneratorClient'
import styles from './DebtQuiz.module.scss'
import { Typography, TypographyLongForm } from 'components/Contentful'
import { LinearProgress } from '@achieve/ascend'
import { Image } from 'components/Image'

const QuizResultPage = ({ resultList = [], pageDisclosure }) => {
  return resultList.length > 0 ? (
    <>
      {resultList.map((section) => {
        const lazyLoad = false
        return (
          <ChildComponentGeneratorClient
            uiComponent={section?.fields?.uiComponent}
            isCrawler={false}
            lazyLoad={lazyLoad}
            {...section}
            key={section?.sys?.id}
          />
        )
      })}
      {pageDisclosure && (
        <div
          className="text-blue-800 mt-12 px-4 lg:px-8 max-w-(--breakpoint-xl) mx-auto [&_p]:leading-normal [&_p:not(:last-child)]:mb-4 [&_ol]:pl-4 [&_ol>li]:mb-6 [&_li::marker]:text-[11px]"
          data-testid="result-page-disclosure"
        >
          <TypographyLongForm content={pageDisclosure} variant="bodyXs" fontWeight="regular" />
        </div>
      )}
    </>
  ) : (
    <div className={styles['result-section']}>
      <div>
        <Image alt="Calculating your Debt Fit™ Score" width="224" height="189" src="/loader.gif" />
      </div>
      <div>
        <Typography
          variant="headingMd"
          className={styles['loader-text']}
          content="Calculating your Debt Fit™ Score..."
        />
      </div>
      <div className={styles['progress-container']}>
        <div>
          <LinearProgress />
        </div>
      </div>
    </div>
  )
}

export default QuizResultPage
